// extracted by mini-css-extract-plugin
module.exports = {"debugWrapper":"Debug__debugWrapper___3ENFw","debug":"Debug__debug___1uqiI","debugSection":"Debug__debugSection___1PoLO","debugSectionLabel":"Debug__debugSectionLabel___2MyVs"};